module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_1.462a4902.png";